import styled from 'styled-components';

import { breakpoints } from '~/styles/breakpoints';
import grid from '~/styles/grid';

interface TabProps {
  active: boolean;
}

export const Container = styled.div``;

export const TabPanel = styled.div`
  display: flex;
  align-items: end;
  margin: 2.8rem 0;
  height: ${grid.lg};
  column-gap: ${grid.md};

  @media (max-width: ${breakpoints.sm}) {
    margin-left: 70px;
  }
`;

export const Tab = styled.h1<TabProps>`
  margin-bottom: ${(props) => (props.active ? '0px' : '2px')} !important;
  transition: 0.2s;
  font-size: ${(props) => (props.active ? grid.lg : grid.md)};
  color: ${(props) => (props.active ? '#1a1a1a' : '#b3b3b3')};
`;

export const TabButton = styled.button`
  background: none;
  border: none;
`;
